import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fe9cfda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-content generate-key--container text-center" }
const _hoisted_2 = { class: "ibf-h1-larger login-title" }
const _hoisted_3 = { class: "login-subtitle mt-[24px] text-Text/text_low text-[18px]" }
const _hoisted_4 = { class: "items-center" }
const _hoisted_5 = { class: "mt-[296px]" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_7 = {
  id: "login-support-link",
  class: "mr-[9px] mt-[28px] underline"
}
const _hoisted_8 = ["href"]

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton } from 'incredi-ui';
import { useRouter } from 'vue-router';
import { Routes } from '@/router/router.const';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'expiredLicenseForm',
  emits: ["loading"],
  setup(__props, { emit }: { emit: ({
  (e: 'loading', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const supportMailUrl = process.env.VUE_APP_SUPPORT_MAIL;
const router = useRouter();

const goToUploadLicense = async () => {
  await router.push({ name: Routes.EnterLicense });
};

onMounted(() => {
  emit('loading', false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.expiredLicenseForm.title')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.expiredLicenseForm.subtitle.A')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.expiredLicenseForm.subtitle.B')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.expiredLicenseForm.subtitle.C')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(IncrediButton), {
              size: "big",
              class: "w-[306px] !rounded-[50px] block !h-[40px] !bg-Text/text_high italic text-[15px] !font-gordita-bold-italic !text-System/app_white",
              design: "primary-green",
              onClick: _withModifiers(goToUploadLicense, ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              tabindex: "4",
              href: _unref(supportMailUrl)
            }, _toDisplayString(_ctx.$t('login.licenseForm.supportLink')), 9, _hoisted_8)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})